
import React from 'react';
import { type Gift, type Brand, type MarketAction } from '@/utils/types';
import ConsumeAction from './actions/ConsumeAction';
import ExchangeAction from './actions/ExchangeAction';
import RegiftAction from './actions/RegiftAction';
import ConvertAction from './actions/ConvertAction';

interface MarketActionContentProps {
  activeTab: MarketAction;
  selectedGift: Gift | null;
  targetGift: Gift | null;
  targetEmail: string;
  brands: Brand[];
  onTargetGiftChange: (gift: Gift) => void;
  onTargetEmailChange: (email: string) => void;
  onAction: () => void;
  onShowQRCode?: () => void;
}

const MarketActionContent: React.FC<MarketActionContentProps> = ({
  activeTab,
  selectedGift,
  targetGift,
  targetEmail,
  brands,
  onTargetGiftChange,
  onTargetEmailChange,
  onAction,
  onShowQRCode
}) => {
  if (!selectedGift) return null;

  const handleShowQRCode = () => {
    console.log("QR CODE TRIGGER: Via handleShowQRCode in MarketActionContent");
    if (onShowQRCode) {
      onShowQRCode();
    } else {
      console.error("onShowQRCode is not defined");
    }
  };

  const handleAction = () => {
    console.log("MarketActionContent: Handling action for tab:", activeTab);
    onAction();
  };

  switch(activeTab) {
    case 'consume':
      return (
        <ConsumeAction 
          selectedGift={selectedGift}
          brands={brands}
          onShowQRCode={handleShowQRCode}
        />
      );
    
    case 'exchange':
      return (
        <ExchangeAction
          selectedGift={selectedGift}
          targetGift={targetGift}
          brands={brands}
          onTargetGiftChange={onTargetGiftChange}
        />
      );
    
    case 'regift':
      return (
        <RegiftAction
          selectedGift={selectedGift}
          targetEmail={targetEmail}
          brands={brands}
          onTargetEmailChange={onTargetEmailChange}
          onAction={handleAction}
        />
      );
    
    case 'convert':
      return (
        <ConvertAction
          selectedGift={selectedGift}
          brands={brands}
        />
      );
    
    default:
      return null;
  }
};

export default MarketActionContent;
